import {LongueursVente} from '@/models';

export default [
	{
		path: '/longueurs-vente',
		name: 'longueursVente',
		meta: {
			title: 'Liste des longueurs de vente',
			granted: [ 'API_GET_LONGUEURSVENTE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/LongueursVente.vue')
	},
	{
		path: '/longueursVente/edit/:id',
		name: 'longueursVente-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/LongueursVente/Edit.vue'),
				class: LongueursVente
			}),
		},
		meta: {
			title: 'Edition d\'une longueurs de vente',
			granted: [ 'API_PUT_LONGUEURSVENTE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];